import { sendEmailVerification, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import {apiRequest} from './api-request';

// Enable only after the sender domain and server delivery have been verified.
const branded = () => process.env.REACT_APP_BRANDED_EMAILS === 'true';
async function request(type, user, email) {
  if(user&&auth.currentUser?.uid!==user.uid)throw Object.assign(new Error('Account changed'),{code:'auth/requires-recent-login'});
  try {
    await apiRequest('/api/auth-email',{method:'POST',anonymous:!user,withoutToken:!user,timeoutMs:30000,body:{type,...(email?{email}:{})}});
  }catch(error){
    const code=error.status===429?'auth/too-many-requests':/connect|timed out/i.test(error.message)?'auth/network-request-failed':/account changed/i.test(error.message)?'auth/requires-recent-login':'auth/email-delivery-unavailable';
    throw Object.assign(new Error('Email request failed'),{code});
  }
}
export const deliverVerification = user => branded() ? request('verify', user) : sendEmailVerification(user);
export const sendResetEmail = email => branded() ? request('reset', null, email.trim()) : sendPasswordResetEmail(auth, email.trim());
